import React, { useEffect, useState, useContext } from "react";
import apisettings from "../apiSettings";
import awsconfig from '../awsSettings';
import i18n from '../utilities/i18n';

export const ConfigContext = React.createContext();

export const ConfigProvider = ({ children }) => {
  const [KioskConfig, setKioskConfig] = useState();
  const [CustomerConfig, setCustomerConfig] = useState();
  const [EnabledFeatures, setEnabledFeatures] = useState();
  const [StyleConfig, setStyleConfig] = useState();


  useEffect(() => {
    async function fetchCustomerStyle(customer) {

      return fetch(`https://${awsconfig.Storage.AWSS3.bucket}.s3-${awsconfig.Storage.AWSS3.region}.amazonaws.com/public/${customer}/styles/kiosk/customStyles.json`)
        .then((data) => data.json())
        .then((data) => {
          console.log("customStyles.json loaded!", data);
          return data;
        })
        .catch((err) => {
          console.log("customStyles.json not loaded, still happy.");
          return {};
        });
    }


    async function fetchKioskConfig() {
      return fetch(apisettings.BASE_URL + "/GetConfig")
        .then((data) => {
          return data.json();
        })
        .then((data) => {
          return data;
        })
        .catch((error) => {
          console.log(error);
        });
    }

    async function fetchCustomerConfig() {
      return fetch(apisettings.BASE_URL + "/WhoAmI")
        .then((data) => {
          return data.json();
        })
        .then((data) => {
          return data;
        })
        .catch((error) => {
          console.log(error);
        });
    }

    async function fetchTranslations(language, customer) {
       await fetch(`https://${awsconfig.Storage.AWSS3.bucket}.s3-${awsconfig.Storage.AWSS3.region}.amazonaws.com/public/${customer}/text/kiosk/texts-${language}.json`)
        .then(data => data.json())
        .then(data => {
          i18n.addResourceBundle(language, 'combined', data);
          console.log(`texts-${language}.json loaded!`);
        })
        .catch(error => { console.log(error) });

       await fetch(`/global-${language}.json`)
        .then(data => data.json())
        .then(data => {
          i18n.addResourceBundle(language, 'combined', data);
          console.log(`global-${language}.json loaded!`);
        })
        .catch(error => { console.log(`error loading /global-${language}.json! ` + error) });
    }

    async function fetchAllConfigsAndTranslations() {
      let kioskConfig = await fetchKioskConfig();
      let customerConfig = await fetchCustomerConfig();
      let styleConfig = await fetchCustomerStyle(customerConfig.Customer);
      if (customerConfig.EnabledFeatures && customerConfig.EnabledFeatures.includes("multilingual")) {
        if (customerConfig.SupportedLanguages && customerConfig.SupportedLanguages.length > 0) {
          for (const lang of customerConfig.SupportedLanguages) {
            await fetchTranslations(lang, customerConfig.Customer);
          }
        }
      }
      else {
        await fetchTranslations('nl', customerConfig.Customer);
      }
      console.log("All configs and translations loaded!");
      setKioskConfig(kioskConfig);
      setStyleConfig(styleConfig);
      setEnabledFeatures(customerConfig.EnabledFeatures);
      setCustomerConfig(customerConfig);
      console.log("All configs and translations set!");
    }

    fetchAllConfigsAndTranslations();
  }, []);

  if (StyleConfig && KioskConfig && CustomerConfig && EnabledFeatures) {
    return (
      <ConfigContext.Provider
        value={{ KioskConfig, CustomerConfig, StyleConfig, EnabledFeatures }}
      >
        {children}
      </ConfigContext.Provider>
    );
  }
  return "Loading...."
};

export const useConfig = () => useContext(ConfigContext);
